export const ACTION_ADD_BANNERS = 'ACTION_ADD_BANNERS';

export const ACTION_LOAD_BANNERS__REQUEST = 'ACTION_LOAD_BANNERS__REQUEST';
export const ACTION_LOAD_BANNERS__SUCCESS = 'ACTION_LOAD_BANNERS__SUCCESS';
export const ACTION_LOAD_BANNERS__FAIL = 'ACTION_LOAD_BANNERS__FAIL';

export const ACTION_BANNER__REQUEST = 'ACTION_BANNER__REQUEST';
export const ACTION_BANNER__SUCCESS = 'ACTION_BANNER__SUCCESS';
export const ACTION_BANNER__FAIL = 'ACTION_BANNER__FAIL';

export const ACTION_DELETE_BANNER__REQUEST = 'ACTION_DELETE_BANNER__REQUEST';
export const ACTION_DELETE_BANNER__SUCCESS = 'ACTION_DELETE_BANNER__SUCCESS';
export const ACTION_DELETE_BANNER__FAIL = 'ACTION_DELETE_BANNER__FAIL';

export const ACTION_LOAD_SITE_BANNERS_EXCHANGE__REQUEST = 'ACTION_LOAD_SITE_BANNERS_EXCHANGE__REQUEST';
export const ACTION_LOAD_SITE_BANNERS_EXCHANGE__SUCCESS = 'ACTION_LOAD_SITE_BANNERS_EXCHANGE__SUCCESS';
export const ACTION_LOAD_SITE_BANNERS_EXCHANGE__FAIL = 'ACTION_LOAD_SITE_BANNERS_EXCHANGE__FAIL';

export const ACTION_EXCHANGE_BANNER__REQUEST = 'ACTION_EXCHANGE_BANNER__REQUEST';
export const ACTION_EXCHANGE_BANNER__SUCCESS = 'ACTION_EXCHANGE_BANNER__SUCCESS';
export const ACTION_EXCHANGE_BANNER__FAIL = 'ACTION_EXCHANGE_BANNER__FAIL';
